import { ReactNode } from 'react';
import t from 'react-translate';

const PopoverList = ({ children }: { children: ReactNode }) => (
  <div>
    <div className='gray-3 font-weight-bold mb-2'>
      {t.MENTORING_PROGRAMS.REPORTING.DOWNLOAD_INCLUDES()}
    </div>
    <ul className='pl-4 mb-0'>
      {children}
    </ul>
  </div>
);

const PREDEFINED_KEYS: Record<string, string[]> = {
  PROGRAM_ENGAGEMENT_POPOVER: [
    'MENTOR_NAME',
    'MENTEE_NAME',
    'MATCHED_DATE',
    'MEETING_PLAN_CADENCE',
    'MEETING_PLAN_ENDS_DATE',
    'MEETING_PLAN_DURATION',
    'SESSIONS_TOTAL',
    'SESSIONS_PAST',
    'SESSIONS_UPCOMING',
    'ACTION_ITEMS_TOTAL',
    'ACTION_ITEMS_OUTSTANDING',
    'ACTION_ITEMS_COMPLETE',
    'ACTION_ITEMS_TOTAL_MENTOR_OWNED',
    'ACTION_ITEMS_TOTAL_MENTEE_OWNED',
    'MENTOR_LAST_VISIT',
    'MENTEE_LAST_VISIT',
    'LAST_SESSION_DATE',
  ],
  PULSE_CHECKS_POPOVER: [
    'MENTOR_NAME',
    'MENTEE_NAME',
    'SESSION_DATE',
    'MENTEE_RESPONSE',
    'MENTOR_RESPONSE',
    'MENTEE_RESPONSE_DATE',
    'MENTOR_RESPONSE_DATE',
  ],
  DEVELOPMENT_GOALS_POPOVER: [
    'USERS_EMAIL',
    'EXTERNAL_ID',
    'FIRST_NAME',
    'LAST_NAME',
    'GOAL_CREATION_DATE',
    'GOAL',
    'STATUS',
  ],
  PARTICIPANT_PROGRAM_PROFILES_POPOVER: [
    'USERS_EMAIL',
    'EXTERNAL_ID',
    'FIRST_NAME',
    'LAST_NAME',
    'HEADLINE',
    'BIO',
    'CITY',
    'STATE',
    'COUNTRY',
    'ORG_LEVEL_QUESTIONS',
    'PROGRAM_LEVEL_QUESTIONS',
  ],
  PROGRAM_REFLECTIONS_POPOVER: [
    'MENTOR_EMAIL',
    'MENTEE_EMAIL',
    'MENTOR_FIRST_NAME',
    'MENTOR_LAST_NAME',
    'MENTEE_FIRST_NAME',
    'MENTEE_LAST_NAME',
    'MENTEE_RESPONSES',
    'MENTOR_RESPONSES',
    'MENTEE_RESPONSE_DATE_AND_TIME',
    'MENTOR_RESPONSE_DATE_AND_TIME',
  ],
};

const DynamicPopover = ({ popoverKey, aliases }: { popoverKey: string, aliases?: any }) => {
  const popoverObj = t.MENTORING_PROGRAMS.REPORTING[popoverKey];
  if (!popoverObj) return null;

  const keys = PREDEFINED_KEYS[popoverKey] || Object.keys(popoverObj);

  return (
    <PopoverList>
      {keys.map((key) => {
        const renderText = popoverObj[key];
        return renderText ? (
          <li key={key}>
            {renderText(aliases)}
          </li>
        ) : null;
      })}
    </PopoverList>
  );
};

export const ProgramEngagementPopover = ({ aliases }: { aliases?: any }) => (
  <DynamicPopover popoverKey='PROGRAM_ENGAGEMENT_POPOVER' aliases={aliases} />
);

export const PulseChecksPopover = ({ aliases }: { aliases?: any }) => (
  <DynamicPopover popoverKey='PULSE_CHECKS_POPOVER' aliases={aliases} />
);

export const DevelopmentGoalsPopover = ({ aliases }: { aliases?: any }) => (
  <DynamicPopover popoverKey='DEVELOPMENT_GOALS_POPOVER' aliases={aliases} />
);

export const ParticipantProgramProfilesPopover = ({ aliases }: { aliases?: any }) => (
  <DynamicPopover popoverKey='PARTICIPANT_PROGRAM_PROFILES_POPOVER' aliases={aliases} />
);

export const ProgramReflectionsPopover = ({ aliases }: { aliases?: any }) => (
  <DynamicPopover popoverKey='PROGRAM_REFLECTIONS_POPOVER' aliases={aliases} />
);
